import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useParams, useNavigate } from 'react-router-dom';
// Importa imagens do React
import logo from "../assets/images.png";
import qr from "../assets/QR.png";
import Api from "../api/Api";
import formatarValor from '../formatarValor';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

// Função auxiliar: converte imagem importada em Base64
const toBase64 = (url) =>
  fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );

const FacturaA4 = () => {
  const { id } = useParams();
  const [docId, setdocId] = useState(id);
  const [ultimosPedidos, setUltimosPedidos] = useState([]);
  const [empresa, setEmpresa] = useState(null);
  const [loading, setLoading] = useState(true);
  const pdfRef = useRef();
  const [iframeHeight, setIframeHeight] = useState("500px");
  const [banco1, setbanco1] = useState('');
  const [banco2, setbanco2] = useState('');
  const [nDoc, setnDoc] = useState(null);
  const [vExtenso, setvExtenso] = useState(null);
  const [nome, setNome] = useState('');
  const [nif, setNif] = useState('');
 

  // URL base para imagens da empresa
  //const BASE_IMAGE_URL = 'http://127.0.0.1:8000/img/';
  //const IMG_ALTERNATIVA = 'http://127.0.0.1:8000/img/default.png';
 
  const BASE_IMAGE_URL = 'https://qrorder.milvendas.ao/public/img/';
  const IMG_ALTERNATIVA = 'https://qrorder.milvendas.ao/public/img/default.png';
 
 
  useEffect(() => {
    setdocId(id);
  }, [id]);

  useEffect(() => {
     document.title = "Factura";
   
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

    const totalGeral = ultimosPedidos.reduce((sum, pedido) => sum + parseFloat(pedido.total || 0), 0);

  const fetchData = async () => {
  try {
    const dados = { id: docId };
    setLoading(true);

    // Primeiro busca pedidos, empresa, contas e documento
    const [pedidosData, empresaData, empresaConta, dadosDocumento] = await Promise.all([
      Api.ListPedidoFactura(dados),
      Api.ListEmpresa(),
      Api.ListConta(),
      Api.LisDocumento(dados),
    ]);

    // Processa os pedidos
    if (Array.isArray(pedidosData)) {
      const formatado = pedidosData.map((item) => ({
        produto: item.produto,
        qtd: item.quantidade,
        total: item.total,
        valor: item.preco,
      }));
      setUltimosPedidos(formatado);
    }

    // Processa os dados da empresa
    if (empresaData) {
      const empresaFormatada = Array.isArray(empresaData) ? empresaData[0] : empresaData;
      if (empresaFormatada) {
        setEmpresa({
          ...empresaFormatada,
          img: empresaFormatada.img
            ? (empresaFormatada.img.startsWith("http")
                ? empresaFormatada.img
                : `${BASE_IMAGE_URL}${empresaFormatada.img}`)
            : null,
        });
      }
    }

    // Processa as contas da empresa (formato IBAN | Banco)
    if (Array.isArray(empresaConta)) {
      if (empresaConta.length > 0) {
        setbanco1(`${empresaConta[0].iban} | ${empresaConta[0].banco}`);
      }
      if (empresaConta.length > 1) {
        setbanco2(`${empresaConta[1].iban} | ${empresaConta[1].banco}`);
      }
    }

    // Processa o documento
    let docFormatado = null;
    if (dadosDocumento) {
      docFormatado = Array.isArray(dadosDocumento)
        ? dadosDocumento[0]
        : dadosDocumento;

      setnDoc(docFormatado);
    }

    // Só depois de ter o documento é que pegamos o extenso
if (docFormatado?.total) {

  const _dados={id:docId};
  const valorExtenso = await Api.GetExtenso(_dados);
  // pega só a string do campo extenso
  setvExtenso(valorExtenso.extenso);


  const cliente = await Api.ListNome(_dados);
  setNome(cliente.nome);
  setNif(cliente.nif);
}


  } catch (error) {
    console.error("Erro ao carregar dados:", error);
  } finally {
    setLoading(false);
  }
};






  // Função para formatar data atual
const getCurrentDateTime = () => {
  if (!nDoc?.dataemissao) return "";

  // Converte "2025-09-27 11:35:00" em formato válido para Date
  const [datePart, timePart] = nDoc.dataemissao.split(" "); // ["2025-09-27", "11:35:00"]
  const isoString = `${datePart}T${timePart}`; // "2025-09-27T11:35:00"

  const data = new Date(isoString);

  if (isNaN(data.getTime())) {
    return nDoc.dataemissao; // fallback: mostra como veio
  }

  const date = data.toLocaleDateString("pt-BR");
  const time = data.toLocaleTimeString("pt-BR");
  return `${date} ${time}`;
};

const dataVencimento = () => {
  if (!nDoc?.datavencimento) return "";

  // Converte "2025-09-27 11:35:00" em formato válido para Date
  const [datePart, timePart] = nDoc.datavencimento.split(" "); // ["2025-09-27", "11:35:00"]
  const isoString = `${datePart}T${timePart}`; // "2025-09-27T11:35:00"

  const data = new Date(isoString);

  if (isNaN(data.getTime())) {
    return nDoc.datavencimento; // fallback: mostra como veio
  }

  const date = data.toLocaleDateString("pt-BR");
  const time = data.toLocaleTimeString("pt-BR");
  return `${date} ${time}`;
};






 

  // Função para gerar número de factura sequencial
 

  const generatePDF = async (companyLogo, QrCod) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Converte os pedidos em formato da tabela
    const data = ultimosPedidos.map((p) => [
      p.produto,
      formatarValor(p.valor),
      p.qtd,
      formatarValor(p.total),
    ]);

    // Calcula o total geral
  
    // Função para converter número em texto (ex: 1000 → "MIL KWANZAS")
    

    // Cabeçalho
    const addHeaderAndFooter = (pageNum, totalPages) => {
      // Logo da empresa
      if (companyLogo) {
        doc.addImage(companyLogo, "PNG", 10, 10, 30, 30);
      }

      // Dados da empresa (dinâmicos)
      doc.setFontSize(8);
      if (empresa) {
        doc.text(empresa.nome || "Empresa não cadastrada", 45, 15);
        doc.text(`NIF: ${empresa.nif || "N/A"}`, 45, 20);
        doc.text(empresa.endereco || "Endereço não informado", 45, 25);
        doc.text(`Telefone: ${empresa.telefone || "N/A"}`, 45, 30);
        doc.text(`Email: ${empresa.email || "N/A"}`, 45, 35);
        if (empresa.site) {
          doc.text(`Site: ${empresa.site}`, 45, 40);
        }
      } else {
        doc.text("Dados da empresa não disponíveis", 45, 15);
      }

      // Número da factura e operador
      doc.setFont("helvetica", "bold");
      doc.text(nDoc.numero, 10, 44);
      doc.setFont("helvetica", "normal");
      

      // Linhas separadoras
      doc.setLineWidth(0.5);
      doc.line(10, 45, pageWidth - 10, 45);
      doc.text(
        `Data de emissão: ${getCurrentDateTime()} | Vencimento: `+ dataVencimento(),
        10,
        49
      );
      doc.line(10, 51, pageWidth - 10, 51);

      // Dados do cliente
      doc.text(nome, 10, 54);
      doc.text("NIF: "+nif, 10, 58);
      doc.text("Obs.:", 10, 62);

      // Totais
      doc.text(formatarValor(totalGeral.toString()), pageWidth - 10, pageHeight - 70, {
        align: "right",
      });
      doc.text("Total documento:", pageWidth - 80, pageHeight - 70);
doc.text(
  vExtenso || "",
  pageWidth - 10,
  pageHeight - 66,
  { align: "right" }
);



      // Informações bancárias
      doc.line(10, pageHeight - 82, pageWidth - 8, pageHeight - 82);
      doc.text(banco1, 10, pageHeight - 79);
      doc.text(banco2, 10, pageHeight - 75);

      // Rodapé
      const longText = "Processado por computador, Software QR Order - MIL VENDAS";
      const splitText = doc.splitTextToSize(longText, pageWidth - 52);
      doc.text(splitText, 10, pageHeight - 51);

      // QR Code
       

      // Número da página
      doc.text(
        `Página ${pageNum} de ${totalPages}`,
        pageWidth - 20,
        pageHeight - 10,
        { align: "right" }
      );
    };

    // Tabela principal
    doc.autoTable({
      head: [["DESCRIÇÃO", "P. UNITÁRIO", "QTD.", "TOTAL"]],
      body: data,
      styles: { fontSize: 8, cellPadding: 1 },
      startY: 72,
      margin: { top: 72, bottom: 68, left: 10, right: 95 },
      columnStyles: {
        0: { cellWidth: 90, halign: "left" }, // DESCRIÇÃO
        1: { cellWidth: 35, halign: "right" }, // P. UNITÁRIO
        2: { cellWidth: 20, halign: "center" }, // QTD.
        3: { cellWidth: 35, halign: "right" }, // TOTAL
      },
    });

    // Cabeçalho/rodapé em todas as páginas
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      addHeaderAndFooter(i, totalPages);
    }

    return { doc, pageHeight };
  };

  useEffect(() => {
    const loadPDF = async () => {
      if (ultimosPedidos.length === 0 || loading) return;

      try {
        // Tenta usar a imagem da empresa, senão usa a imagem padrão
        let logoBase64;
        if (empresa && empresa.img) {
          try {
            logoBase64 = await toBase64(empresa.img);
          } catch (error) {
            console.warn("Erro ao carregar logo da empresa, usando padrão:", error);
            logoBase64 = await toBase64(logo);
          }
        } else {
          logoBase64 = await toBase64(logo);
        }

        const qrBase64 = await toBase64(qr);

      const { doc, pageHeight } = await generatePDF(logoBase64, qrBase64);

// 1️⃣ Gerar blob
const pdfBlob = doc.output("blob");
const pdfUrl = URL.createObjectURL(pdfBlob);

// 2️⃣ Fazer download automático
const link = document.createElement("a");
link.href = pdfUrl;
link.download = `Factura-${nDoc?.numero || docId}.pdf`;
document.body.appendChild(link);
link.click();
document.body.removeChild(link);

// Aguarda 800ms e fecha a janela
setTimeout(() => {
  window.close();
}, 800);

// 3️⃣ Continuar mostrando no iframe (opcional)
if (pdfRef.current) {
  pdfRef.current.src = pdfUrl;
  setIframeHeight(pageHeight * 4 + "px");
}

      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
      }
    };

    loadPDF();
  }, [ultimosPedidos, empresa, loading]);

if (loading) {
  const antIcon = <LoadingOutlined style={{ fontSize: 48, color: '#f98244' }} spin />;
  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      height: "100vh", 
      flexDirection: "column", 
      gap: 16, 
      background: '#f8f9fa' 
    }}>
      <Spin indicator={antIcon} />
      <span style={{ fontSize: 18, color: '#333', fontWeight: 'bold' }}>
        Gerando documento, aguarde...
      </span>
    </div>
  );
}

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <iframe
        ref={pdfRef}
        width="100%"
        height={iframeHeight}
        style={{ border: "none" }}
        title="Factura PDF"
      />
    </div>
  );
};

export default FacturaA4;